import React from "react";
import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../lib/assets";

const CHAPTERS = [
  {
    no: "01",
    title: "Who We Are",
    body:
      "Houston Title Co. is redefining what clients should expect from a title company — a private, deliberate experience where every closing is handled with intention.",
  },
  {
    no: "02",
    title: "Our Mission",
    body:
      "Provide the highest level of communication, professionalism and precision for residential, commercial and development transactions throughout Texas.",
  },
];

export const About = () => {
  return (
    <section id="about" className="relative bg-ink py-28 md:py-40" data-testid="about">
      {/* Editorial marquee */}
      <div className="border-y border-charcoal/50 py-6 mb-24 md:mb-36">
        <Marquee speed={38} gradient={false} autoFill>
          {["Experience", "Integrity", "Results"].map((w, i) => (
            <span
              key={i}
              className="font-serif italic text-3xl md:text-5xl text-taupe/40 mx-12 flex items-center gap-12"
            >
              {w}
              <span className="text-gold/60 not-italic">✦</span>
            </span>
          ))}
        </Marquee>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-8 items-start">
          {/* Left: label + image */}
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="relative overflow-hidden aspect-[4/5] max-w-md">
                <img
                  src={IMAGES.marbleInterior}
                  alt="Marble and brass private office"
                  className="h-full w-full object-cover transition-transform [transition-duration:1400ms] hover:scale-105"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-gold/20" />
              </div>
            </Reveal>
          </div>

          {/* Right: chapters */}
          <div className="lg:col-span-6 lg:col-start-7">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.1} className="mb-16 last:mb-0">
                <div className="flex items-baseline gap-6">
                  <span className="font-serif text-gold text-xl">{c.no}</span>
                  <div className="flex-1">
                    <h3 className="font-serif text-4xl md:text-5xl text-ivory font-light mb-6">
                      {c.title}
                    </h3>
                    <p className="text-taupe text-base md:text-lg leading-relaxed font-light max-w-xl">
                      {c.body}
                    </p>
                  </div>
                </div>
                {i === 0 && <div className="hairline mt-14 max-w-xl ml-12" />}
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
